/* Error boundary around the widget tree. React boundaries are scoped to their
   own subtree, so on a partner page this catches OUR render crashes only —
   never the host site's. Reports the crash (when error tracking is built in)
   and shows a small recover card instead of a white hole in the page. */
import { Component } from "react";
import { reportError } from "./sentryClient.js";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { crashed: false };
  }
  static getDerivedStateFromError() {
    return { crashed: true };
  }
  componentDidCatch(error, info) {
    reportError(error, { where: "render", componentStack: String(info?.componentStack || "").slice(0, 400) });
  }
  render() {
    if (!this.state.crashed) return this.props.children;
    return (
      <div style={{ fontFamily: "system-ui, sans-serif", border: "1px solid #E4EAF2", borderRadius: 16, padding: "28px 24px", maxWidth: 480, background: "#fff", color: "#101828" }}>
        <div style={{ fontWeight: 700, marginBottom: 8 }}>Something went wrong loading the form</div>
        <div style={{ fontSize: 14, lineHeight: 1.6, color: "#344054", marginBottom: 16 }}>
          Sorry about that - it's on our side and we've been notified. Your progress is saved.
        </div>
        <button
          onClick={() => this.setState({ crashed: false })}
          style={{ background: "#2864F0", color: "#fff", border: 0, borderRadius: 999, padding: "10px 22px", fontSize: 15, fontWeight: 600, cursor: "pointer" }}
        >
          Try again
        </button>
      </div>
    );
  }
}
